//Draft Router
const Draft = () => import(/* webpackChunkName: "Draft" */ '../views/Draft')
const DigitalScreenDraft = () => import(/* webpackChunkName: "DigitalScreenDraft" */ '../views/Draft/DigitalScreen')
const BusDraft = () => import(/* webpackChunkName: "Bus" */ '../views/Bus/Draft')


const draftRouter = [
    {
      path: '/draft',
      name: 'draft',
      component: Draft,
      redirect: '/draft/digital-screen',
      meta: { requiresAuth: true },
      children: [
        {
          path: '/draft/digital-screen',
          name: 'digitalscreendraft',
          component: DigitalScreenDraft,
        },
        {
          path: '/draft/bus',
          name: 'busdraft',
          component: BusDraft,
        },
      ]
    },
]

export default draftRouter;
